<template>
    <div id="main">
        <!-- begin:: Page -->
        <div class="m-grid m-grid--hor m-grid--root m-page" style="overflow:hidden;">
            <!-- BEGIN: Header -->
            <header id="m_header" class="m-grid__item m-header " m-minimize-offset="200" m-minimize-mobile-offset="200">
                <div class="m-container m-container--fluid m-container--full-height">
                    <div class="m-stack m-stack--ver m-stack--desktop">
                        <!-- BEGIN: Brand -->
                        <div class="m-stack__item m-brand m-brand--skin-dark ">
                            <div class="m-stack m-stack--ver m-stack--general">
                                <div class="m-stack__item m-stack__item--middle m-brand__logo" style="width: 180px;">
                                    <a href="/main.html" style="font-size: 18px;color: #FFFFFF;text-decoration: none;"
                                        id="menutitle">

                                    </a>
                                </div>
                                <div class="m-stack__item m-stack__item--middle m-brand__tools">
                                    <!-- BEGIN: Left Aside Minimize Toggle -->
                                    <a href="javascript:;" id="m_aside_left_minimize_toggle"
                                        class="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-desktop-inline-block  ">
                                        <span></span>
                                    </a>
                                    <!-- END -->
                                    <!-- BEGIN: Responsive Aside Left Menu Toggler -->
                                    <a href="javascript:;" id="m_aside_left_offcanvas_toggle"
                                        class="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-tablet-and-mobile-inline-block">
                                        <span></span>
                                    </a>
                                    <!-- END -->
                                    <!-- BEGIN: Responsive Header Menu Toggler -->
                                    <a id="m_aside_header_menu_mobile_toggle" href="javascript:;"
                                        class="m-brand__icon m-brand__toggler m--visible-tablet-and-mobile-inline-block">
                                        <span></span>
                                    </a>
                                    <!-- END -->
                                    <!-- BEGIN: Topbar Toggler -->
                                    <a id="m_aside_header_topbar_mobile_toggle" href="javascript:;"
                                        class="m-brand__icon m--visible-tablet-and-mobile-inline-block">
                                        <i class="flaticon-more"></i>
                                    </a>
                                    <!-- BEGIN: Topbar Toggler -->
                                </div>
                            </div>
                        </div>
                        <!-- END: Brand -->
                        <div class="m-stack__item m-stack__item--fluid m-header-head" id="m_header_nav">
                            <!-- BEGIN: Horizontal Menu -->
                            <button
                                class="m-aside-header-menu-mobile-close  m-aside-header-menu-mobile-close--skin-dark "
                                id="m_aside_header_menu_mobile_close_btn">
                                <i class="la la-close"></i>
                            </button>
                            <div id="m_header_menu"
                                class="m-header-menu m-aside-header-menu-mobile m-aside-header-menu-mobile--offcanvas  m-header-menu--skin-dark m-header-menu--submenu-skin-light m-aside-header-menu-mobile--skin-dark m-aside-header-menu-mobile--submenu-skin-dark ">
                                <ul class="m-menu__nav  m-menu__nav--submenu-arrow  ">
                                    <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                                        m-menu-submenu-toggle="click" m-menu-link-redirect="1" aria-haspopup="true"
                                        id="liCommonlyUsed">
                                        <a href="javascript:;" class="m-menu__link m-menu__toggle">
                                            <i class="m-menu__link-icon flaticon-add"></i>
                                            <span class="m-menu__link-text" style="font-size: 1.2rem;">
                                                常用操作
                                            </span>
                                            <i class="m-menu__hor-arrow la la-angle-down"></i>
                                            <i class="m-menu__ver-arrow la la-angle-right"></i>
                                        </a>
                                        <div class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--left">
                                            <ul class="m-menu__subnav" v-html="tabMenu">
                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div v-show="systemtype==2" id="m_header_menu"
                                class="m-header-menu m-aside-header-menu-mobile m-aside-header-menu-mobile--offcanvas  m-header-menu--skin-dark m-header-menu--submenu-skin-light m-aside-header-menu-mobile--skin-dark m-aside-header-menu-mobile--submenu-skin-dark ">
                                <ul class="m-menu__nav  m-menu__nav--submenu-arrow  ">
                                    <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel">
                                        <a href="javascript:;" class="m-menu__link m-menu__toggle"
                                            @click="JumpToOtherApp('http://wxrm.pangpeisoft.com:8180/login.html')">
                                            <i class="m-menu__link-icon flaticon-app"></i>
                                            <span class="m-menu__link-text" style="font-size: 1.2rem;">
                                                住培轮转
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div v-show="systemtype==1" id="m_header_menu"
                                class="m-header-menu m-aside-header-menu-mobile m-aside-header-menu-mobile--offcanvas  m-header-menu--skin-dark m-header-menu--submenu-skin-light m-aside-header-menu-mobile--skin-dark m-aside-header-menu-mobile--submenu-skin-dark ">
                                <ul class="m-menu__nav  m-menu__nav--submenu-arrow  ">
                                    <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel">
                                        <a href="javascript:;" class="m-menu__link m-menu__toggle"
                                            @click="JumpToOtherApp('http://wxrm.pangpeisoft.com:8182/login.html')">
                                            <i class="m-menu__link-icon flaticon-app"></i>
                                            <span class="m-menu__link-text" style="font-size: 1.2rem;">
                                                专硕轮转
                                            </span>
                                        </a>
                                    </li>
                                    <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel">
                                        <a href="javascript:;" class="m-menu__link m-menu__toggle"
                                            @click="JumpToJavaApp('http://wxrm.pangpeisoft.com:12019/login.html')">
                                            <i class="m-menu__link-icon flaticon-app"></i>
                                            <span class="m-menu__link-text" style="font-size: 1.2rem;">
                                                教学管理
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <!-- END: Horizontal Menu -->
                            <!-- BEGIN: Topbar -->
                            <div id="m_header_topbar" class="m-topbar  m-stack m-stack--ver m-stack--general">
                                <div class="m-stack__item m-topbar__nav-wrapper">
                                    <ul class="m-topbar__nav m-nav m-nav--inline">
                                        <li class="m-nav__item m-topbar__quick-actions m-dropdown m-dropdown--skin-light m-dropdown--large m-dropdown--arrow m-dropdown--align-right m-dropdown--align-push m-dropdown--mobile-full-width"
                                            m-dropdown-toggle="click" id="liRemind">
                                            <a href="#" class="m-nav__link m-dropdown__toggle"
                                                id="m_topbar_notification_icon">
                                                <span class="m-nav__link-icon">
                                                    <span class="m-nav__link-icon-wrapper">
                                                        <i class="flaticon-music-2"></i>
                                                    </span>
                                                    <span class="m-nav__link-badge m-badge m-badge--danger"
                                                        id="sTitle">0
                                                    </span>
                                                </span>
                                            </a>
                                            <div class="m-dropdown__wrapper">
                                                <span
                                                    class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"></span>
                                                <div class="m-dropdown__inner">
                                                    <div class="m-dropdown__header m--align-center">
                                                        <span class="m-dropdown__header-title">
                                                            <span id="sAllCheckCount">0</span> 条待审核数据
                                                        </span>
                                                    </div>
                                                    <div class="m-dropdown__body">
                                                        <div class="m-dropdown__content">
                                                            <div class="tab-content">
                                                                <div class="tab-pane active"
                                                                    id="topbar_notifications_notifications"
                                                                    role="tabpanel">
                                                                    <div class="m-scrollable" data-scrollable="true"
                                                                        data-height="250" data-mobile-height="200">
                                                                        <div
                                                                            class="m-list-timeline m-list-timeline--skin-light">
                                                                            <div class="m-list-timeline__items"
                                                                                id="dCheck">
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li class="m-nav__item m-topbar__user-profile  m-dropdown m-dropdown--medium m-dropdown--arrow  m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light"
                                            m-dropdown-toggle="click">
                                            <a href="#" class="m-nav__link m-dropdown__toggle">
                                                <span class="m-topbar__userpic">
                                                    <img src="../../assets/image/logo_wx.jpg"
                                                        class="m--img-rounded m--marginless m--img-centered" alt="" />
                                                </span>
                                                <span class="m-nav__link-icon m-topbar__usericon  m--hide">
                                                    <span class="m-nav__link-icon-wrapper">
                                                        <i class="flaticon-user-ok"></i>
                                                    </span>
                                                </span>
                                            </a>
                                            <div class="m-dropdown__wrapper">
                                                <span
                                                    class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"></span>
                                                <div class="m-dropdown__inner">
                                                    <div class="m-dropdown__header m--align-center">
                                                        <div class="m-card-user m-card-user--skin-light">
                                                            <div class="m-card-user__pic">
                                                                <img src="../../assets/image/logo_wx.jpg"
                                                                    class="m--img-rounded m--marginless" alt="" />
                                                            </div>
                                                            <div class="m-card-user__details">
                                                                <span class="m-card-user__name m--font-weight-500">
                                                                    {{username}}
                                                                </span>
                                                                <a href="javascript:;"
                                                                    class="m-card-user__email m--font-weight-300 m-link">
                                                                    {{truename}}
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="m-dropdown__body">
                                                        <div class="m-dropdown__content">
                                                            <ul class="m-nav m-nav--skin-light">
                                                                <li class="m-nav__item">
                                                                    <a href="javascript:;" @click="UserInfo()"
                                                                        class="m-nav__link">
                                                                        <i class="m-nav__link-icon flaticon-avatar"></i>
                                                                        <span class="m-nav__link-title">
                                                                            <span class="m-nav__link-wrap">
                                                                                <span class="m-nav__link-text">
                                                                                    个人信息
                                                                                </span>
                                                                            </span>
                                                                        </span>
                                                                    </a>
                                                                </li>
                                                                <li class="m-nav__item">
                                                                    <a href="javascript:;" @click="ChangePwd()"
                                                                        class="m-nav__link">
                                                                        <i class="m-nav__link-icon flaticon-edit"></i>
                                                                        <span class="m-nav__link-text">
                                                                            修改密码
                                                                        </span>
                                                                    </a>
                                                                </li>
                                                                <li class="m-nav__separator m-nav__separator--fit"></li>
                                                                <li class="m-nav__item">
                                                                    <a href="/login.html"
                                                                        class="btn m-btn--pill    btn-secondary m-btn m-btn--custom m-btn--label-brand m-btn--bolder">
                                                                        退出系统
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <!-- END: Topbar -->
                        </div>
                    </div>
                </div>
            </header>
            <!-- END: Header -->
            <!-- begin::Body -->
            <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
                <!-- BEGIN: Left Aside -->
                <div id="m_aside_left" class="m-grid__item m-aside-left m-aside-left--skin-dark">
                    <!-- BEGIN: Aside Menu -->
                    <div id="m_ver_menu" class="m-aside-menu  m-aside-menu--skin-dark m-aside-menu--submenu-skin-dark "
                        m-menu-vertical="1" m-menu-scrollable="1" m-menu-dropdown-timeout="500"
                        style="position: relative;">
                        <ul class="m-menu__nav" id="menuul" v-html="roleMenu">
                        </ul>
                    </div>
                    <!-- END: Aside Menu -->
                </div>
                <!-- END: Left Aside -->
                <div id="iframeContent" class="m-grid__item m-grid__item--fluid m-wrapper" style="overflow:auto;">
                    <div class="m-content" style="padding-top: 30px;overflow: visible;" id="divContent">
                        <!-- <iframe src="main.html" onload="Resize()" id="iframeContent" name="main" scrolling="no" width="100%"
              frameborder="0" class="m-scrollable m-scroller ps ps--active-y" data-scrollable="true"></iframe> -->
                        <router-view />
                    </div>
                </div>
            </div>
            <!-- end:: Body -->
            <!-- begin::Footer -->
            <footer id="footer" class="m-grid__item m-footer">
                <div class="m-container m-container--fluid m-container--full-height m-page__container">
                    <div class="m-stack m-stack--flex-tablet-and-mobile m-stack--ver m-stack--desktop">
                        <div class="m-stack__item m-stack__item--left m-stack__item--middle m-stack__item--last">
                            <span class="m-footer__copyright">
                                技术支持：
                                <a href="https://www.pangpeisoft.com" class="m-link">
                                    南京庞培软件科技有限公司
                                </a>
                            </span>
                        </div>
                        <div class="m-stack__item m-stack__item--right m-stack__item--middle m-stack__item--first">
                            <ul class="m-footer__nav m-nav m-nav--inline m--pull-right">
                                <li class="m-nav__item">
                                    <a href="#" class="m-nav__link">
                                        <span class="m-nav__link-text">
                                            服务电话：025-86464900
                                        </span>
                                    </a>
                                </li>
                                <li class="m-nav__item">
                                    <a href="#" class="m-nav__link">
                                        <span class="m-nav__link-text">
                                            服务QQ：289428419
                                        </span>
                                    </a>
                                </li>
                                <li class="m-nav__item">
                                    <a href="#" class="m-nav__link">
                                        <span class="m-nav__link-text">
                                            帮助文档
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
            <!-- end::Footer -->
        </div>
        <!-- end:: Page -->
    </div>
</template>

<script>
    import $ from 'jquery'
    export default {
        name: 'mainNav',
        data () {
            return {
                roleid: '',
                userid: '',
                rolelevel: '',
                tabMenu: '',
                roleMenu: '',
                username: '',
                truename: '',
                systemtype: 0
            }
        },
        created () {
            window.JumpTo = this.JumpTo
        },
        methods: {
            JumpTo: function (url) {
                this.$router.push(url)
            },
            UserInfo: function () {
                this.$router.push({
                    name: 'IndexUserEdit',
                    params: {
                        id: this.userid
                    }
                })
            },
            ChangePwd: function () {
                this.$router.push({
                    name: 'ChangePwd',
                    params: {
                        id: this.userid
                    }
                })
            },
            JumpToIndex: function () {
                this.$router.push('/main/index/system')
            },
            JumpToOtherApp: function (url) {
                url = sessionStorage.getItem('jumpUrl')
                url = url + '?token=PpRJ135@$^20161110ppRj&username=' + this.username
                window.location.href = url
            },
            JumpToJavaApp: function (url) {
                var args = {
                    username: this.username
                }
                this.$http.post(this.$utils.Url.zpgl + '/api/Login/CreateToken', args)
                    .then(res => {
                        console.log(res)
                        url = url + '?performanceToken=' + res.data.Data + '&username=' + this.username
                        console.log(url)
                        window.location.href = url

                    })
                    .catch(err => {
                        this.roleMenu = ''
                        console.log(err)
                        this.$message({
                            message: '跳转失败',
                            type: 'error'
                        })
                    })

            },

        },
        mounted: function () {
            var iframeContent = document.getElementById("iframeContent");
            var divContent = document.getElementById("divContent");
            if (window.XMLHttpRequest) {
                iframeContent.style.width = "100%";
            } else {
                iframeContent.style.width = (divContent.offsetWidth - 255) + "px";
            }
            divContent.style.height = (document.documentElement.clientHeight - 130) + "px";
            iframeContent.height = 0;
            iframeContent.height = (document.documentElement.clientHeight - 190) + "px";
            window.onresize = () => {
                return (() => {
                    var iframeContent = document.getElementById("iframeContent");
                    var divContent = document.getElementById("divContent");
                    if (window.XMLHttpRequest) {
                        iframeContent.style.width = "100%";
                    } else {
                        iframeContent.style.width = (divContent.offsetWidth - 255) + "px";
                    }
                    divContent.style.height = (document.documentElement.clientHeight - 130) + "px";
                    iframeContent.height = 0;
                    iframeContent.height = (document.documentElement.clientHeight - 190) + "px";
                })()
            }

            this.systemtype = this.$utils.Url.SystemType //住培系统，显示专硕跳转链接，专硕系统 显示住培链接
            this.userid = sessionStorage.getItem('userid')
            this.rolelevel = sessionStorage.getItem('rolelevel')
            this.roleid = sessionStorage.getItem('roleid')
            this.username = sessionStorage.getItem('username')
            this.truename = sessionStorage.getItem('truename')
            document.getElementById('menutitle').innerText = sessionStorage.getItem('sysName')
            var args = {
                token: sessionStorage.getItem('token'),
                userid: this.userid
            }
            this.$http.post(this.$utils.Url.zpgl + '/api/APIPower/UserMenu', args)
                .then(res => {
                    if (res.data.Code === 0) {
                        this.tabMenu = res.data.Data
                    } else {
                        this.$message({
                            message: res.data.Msg + '，' + res.data.Error,
                            type: 'error'
                        })
                    }
                })
                .catch(err => {
                    console.log(err)
                    this.tabMenu = ''
                    this.$message({
                        message: '查询失败',
                        type: 'error'
                    })
                })
            args = {
                token: sessionStorage.getItem('token'),
                roleid: this.roleid,
                rolelevel: this.rolelevel
            }
            this.$http.post(this.$utils.Url.zpgl + '/api/APIPower/RoleMenu', args)
                .then(res => {
                    if (res.data.Code === 0) {
                        this.roleMenu = res.data.Data
                        this.$nextTick().then(() => {
                            var lastSelect
                            var menulist = $(".m-menu__subnav").find(".m-menu__item").find("a")
                            menulist.click(function () {
                                if (lastSelect !== null) {
                                    $(lastSelect).find("span").css("color", "")
                                }
                                menulist.removeClass("aselect")
                                $(this).addClass("aselect")
                                lastSelect = this
                                $(this).find("span").css("color", "#FFFFFF")
                            })
                        })
                    } else {
                        this.$message({
                            message: res.data.Msg + '，' + res.data.Error,
                            type: 'error'
                        })
                    }
                })
                .catch(err => {
                    this.roleMenu = ''
                    console.log(err)
                    this.$message({
                        message: '查询失败',
                        type: 'error'
                    })
                })
            this.JumpToIndex()
        }
    }
</script>

<style scoped="scoped">
    label {
        margin-bottom: 0;
    }

    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    .el-table--medium td,
    .el-table--medium th {
        padding: 6px 0;
    }

    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
        width: 220px;
    }
</style>